export const analyzereConstants = {
  unlimitedValue: 1e21,
}
